import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { SignUp } from '@/features/auth/sign-up'

const searchSchema = z.object({
  ref: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/signup/')({
  validateSearch: searchSchema,
  component: SignUp,
})
